"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utilities_1 = require("./utilities");
const downloads_1 = require("./downloads");
const pageImageEmbeds = Array.from(document.querySelectorAll('.js-page-image-embeds'));
const body = document.getElementsByTagName("body")[0];
if (pageImageEmbeds) {
    if (!document.querySelector('.modal--downloads')) {
        body.insertAdjacentHTML("beforeend", downloads_1.modal);
    }
    const closestModal = document.querySelector('.modal--downloads');
    pageImageEmbeds.forEach((pageImageEmbed) => {
        pageImageEmbed.addEventListener('click', (event) => {
            event.preventDefault();
            const el = event.target;
            (closestModal.classList.contains('hidden')) ? closestModal.classList.remove('hidden') : '';
            const documentBlocker = document.createElement('div');
            documentBlocker.remove();
            documentBlocker.classList.add('modal__blocker');
            document.querySelector('body').appendChild(documentBlocker);
            const imagePageLink = el.href;
            try {
                const pushToModal = (content) => {
                    if (closestModal.children[0].children[0] && content) {
                        closestModal.children[0].children[0].innerHTML = content.innerHTML;
                    }
                };
                (0, utilities_1.fetchPage)(imagePageLink)
                    .then((data) => {
                    let getElements = new DOMParser();
                    //@ts-ignore
                    let element = getElements.parseFromString(data, 'text/html');
                    if (element.querySelector('main')) {
                        let fetchPageContent = element.querySelector('main'); // See comments in GS1WEB-4353. This is stupid, as it technically opens up the possibility to embed entire content pages in modal views.
                        pushToModal(fetchPageContent);
                    }
                    else {
                        let fetchPageContent = Array.from(element.querySelectorAll('.frame'));
                        fetchPageContent.forEach((pageContent) => {
                            pushToModal(pageContent);
                        });
                    }
                }).catch(error => console.error(error));
            }
            catch (error) {
                console.error(`Failed to fetch: ${imagePageLink}`, error);
            }
        });
    });
}
